import React from 'react';
import Layout from './Layout';
import { usePageMeta } from './shared';

export default function About() {
  usePageMeta({
    title: 'About Daniel Bradley | MS Message Center',
    description: 'Learn about Daniel Bradley, Microsoft MVP, and the MS Message Center community project, a faster, cleaner way to browse Microsoft 365 Message Center announcements.',
    url: 'https://msmessagecenter.com/about',
  });

  return (
    <Layout>
      <article className="max-w-screen-md mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50 mb-2">Who am I?</h1>
        <p className="text-base text-gray-500 dark:text-gray-400 mb-8">A short introduction to the person behind this project.</p>

        <div className="space-y-5 text-base text-gray-700 dark:text-gray-300 leading-relaxed">
          <p>
            Hi, I'm <strong>Daniel Bradley</strong>, a Microsoft MVP focused on Microsoft 365, security, and the
            wider Microsoft cloud ecosystem. I work day-to-day helping organisations get more value out of their
            Microsoft 365 estate, with a particular focus on automation, identity, and admin tooling.
          </p>
          <p>
            I built <strong>MS Message Center</strong> as a community project, a faster, cleaner way to browse
            Microsoft 365 Message Center announcements than the official admin portal. It's not affiliated with
            Microsoft in any way, it's just something I wanted to exist.
          </p>
          <p>
            Outside of this site, I write about Microsoft 365 on my blog{' '}
            <a href="https://ourcloudnetwork.com/" target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
              ourcloudnetwork.com
            </a>
            {' '}and run{' '}
            <a href="https://msdocstracker.com/" target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
              MSDocsTracker
            </a>
            , a tool that tracks changes to Microsoft Learn documentation.
          </p>
          <p>
            If you'd like to connect, the best places are{' '}
            <a href="https://www.linkedin.com/in/danielbradley2/" target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
              LinkedIn
            </a>
            {' '}or{' '}
            <a href="https://x.com/DanielatOCN" target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
              X
            </a>
            .
          </p>
        </div>
      </article>
    </Layout>
  );
}
